import { createAction } from 'core/use-cases/utilities';

export const updatePathname = createAction<'@@updatePathname', string>('@@updatePathname');
